import Vue from "vue"
import Router from "vue-router"
import { getCookie, setCookie, delCookie } from "@/utils/cookie"
import { redirectToLoginPage } from "@/utils/auth"
import MainLayout from "@/components/Layout/MainLayout"
import DefaultLayout from "@/components/Layout/DefaultLayout"
import Home from "@/views/default/Home.vue"
import Notice from "@/views/PageNotice.vue"
import Error from "@/views/default/Error.vue"
import reserve from "@/configs/modules/reserve.js"
import release from "@/configs/modules/release.js"
import { store } from "@/store/store"
import { api } from "@/utils/api"

Vue.use(Router)

const router = new Router({
  routes: [
    { path: "/", redirect: "/Home" },
    {
      path: "/Home",
      component: MainLayout,
      children: [
        {
          path: "",
          name: "Home",
          component: Home,
        },
      ],
    },
        {
      path: "/Notice",
      component: MainLayout,
      children: [
        {
          path: "",
          name: "Notice",
          component: Notice,
        },
      ],
    },
    ...reserve,
    ...release,
    {
      path: "/Error",
      component: DefaultLayout,
      children: [
        {
          path: "",
          name: "Error",
          component: Error,
        },
      ],
    },
    {
      path: "/401",
      component: DefaultLayout,
      children: [
        {
          path: "",
          name: "NoAuthorized",
          component: Error,
        },
      ],
    },
    {
      path: "*",
      component: DefaultLayout,
      children: [
        {
          path: "",
          name: "NotFound",
          component: Error,
        },
      ],
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const token = to.query.token
  if (token) {
    setCookie(process.env.VUE_APP_AUTH_TOKEN_NAME, token, 1000 * 60 * 60 * 6)
    store.dispatch("setLogin", true)
    next({ path: "/" })
  }
  if (!getCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)) {
    doWhenNoToken(to, "NoAuthorized")
  } else {
    store.dispatch("setLogin", true)
    if (!store.getters.getUserLoginData.userName) {
      try {
        if (to.name === "" || to.name === "Error" || to.name === "NoAuthorized" || to.name === "NotFound") {
          next()
          return
        }
        const { data: vendorInfo } = await api.apiGetVendorLoginInfo()
        store.dispatch("setVendorInfo", vendorInfo)
        if (vendorInfo.isAvailable === false) {
          next({ path: "/401" })
          return
        }
      } catch (error) {
        store.dispatch("setLogin", false)
        store.dispatch("setVendorInfo", {})
        delCookie(process.env.VUE_APP_AUTH_TOKEN_NAME)
        doWhenNoToken(to, "NoAuthorized")
      }
      if (to.name === "Home") {
        const redirectUrl = sessionStorage.getItem("redirectUrl")
        if (redirectUrl && redirectUrl !== "/" && redirectUrl !== "/Home") {
          sessionStorage.removeItem("redirectUrl")
          next({
            path: redirectUrl,
          })
        } else {
          const { data: noticeIsActive } = await api.apiNGetNoticeIsActive()
          if (noticeIsActive) {
            next({
              path: "/Notice",
            })
          } else {
            next({
              path: "/MyReservation",
            })
          }
        }
      } else {
        next()
      }
    } else {
      next()
    }
  }
})

function doWhenNoToken(to, noPermissionPageName) {
  if (to.name === noPermissionPageName) {
    next()
  } else {
    store.dispatch("setLogin", false)
    sessionStorage.setItem("redirectUrl", to.fullPath)
    redirectToLoginPage()
  }
}

export default router
